import React, { useEffect, useState } from 'react'
import Appbar from '../component/Appbar'
import { useDispatch, useSelector } from 'react-redux'
import Style from './history.module.scss'
import Styles from '../style/trending.module.scss'
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import SmartDisplayOutlinedIcon from '@mui/icons-material/SmartDisplayOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Play_btn from '../../../../assets/img/play_button2.png'
import Fav from '../../../../assets/theme6/fav1.svg'
import Unfav from '../../../../assets/theme6/unfav.svg'
import LimitPopup from '../component/LimitPopup';
import LimitPopup2 from '../component/LimitPopup2';
import { useNavigate } from 'react-router-dom'
import AuthAxios from "../../../../config/authAxios"
import BottomBar from '../component/BottomBar'


function FavoriteMIssion() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [limit, setLimit] = useState(5)
  const [page, setPage] = useState(0)
  const [loading, setLoading] = useState(false)
  const [showPopup, setShowPopup] = useState(false);
  const userDetialsSelector = useSelector(state => state.getUserDetails)
  const { data: { daily_attempt_limit_count } } = userDetialsSelector
  const [missionData, setMissionData] = useState([]);
  const [userScreenWidth, setUserScreenWidth] = useState(null)
  const [open1, setOpen1] = React.useState(false);
  const [hasMore, setHasMore] = useState(false);
  const currentUrl = window.location.href;
window.scrollTo(0,0)
  const fetchFavorite = async () => {
    try {
      setLoading(true)
      const response = await AuthAxios.get(`/users/api/favourite-mission/reward/${page}/${limit}`);
      setHasMore(response?.data?.data.length >= limit)
      setMissionData(prev => [...prev, ...response?.data?.data])
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchFavorite()
    setUserScreenWidth(window.innerWidth)
  }, [page])

  const favHandler = async (value) => {
    await AuthAxios.put(`/users/api/add-favorite-reward/mission`, { challenge_id: value })
    // fetchFavorite();
    setMissionData(prev => prev.filter(item => item._id !== value));
  }
  function getTitle(email) {
    try {
      let deviceHeight = window.innerHeight
      if (email?.length <= 20) {
        return email
      } else {
        var fontSize = 8;
        if (deviceHeight == 768 && userScreenWidth == 393) {
          fontSize = 26
        }

        let remainScreenSize = userScreenWidth - 320;
        let charCanAdjust = Math.floor(remainScreenSize / fontSize);
        if (userScreenWidth <= 360) {
          if (email.length < email.substring(0, 12) + charCanAdjust) {
            return email.substring(0, 12 + charCanAdjust)
          }
          return email.substring(0, 12 + charCanAdjust - 3) + '...'
        } else {
          if (email.length < email.substring(0, 10) + charCanAdjust) {
            return email.substring(0, 10 + charCanAdjust)
          }
          return email.substring(0, 10 + charCanAdjust - 3) + '...'
        }
      }

    } catch (error) {
      console.log(error, "error")
    }


  }

  return (
    <>
      <Appbar />
      <div className={Style.main_div}>
        <div className={Style.history__heading}>
          <h3>Favourite</h3>
        </div>
        <div className={Styles.mission_sec}>
          {loading ? <Box sx={{ width: "95%" }}>
            <Skeleton style={{ borderRadius: "10px" }} animation="wave" variant="rectangular" width={"100%"} height={130} />
            <br />
            <Skeleton style={{ borderRadius: "10px" }} animation="wave" variant="rectangular" width={"100%"} height={130} />
            <br />
            <Skeleton style={{ borderRadius: "10px" }} animation="wave" variant="rectangular" width={"100%"} height={130} />
            <br />
            <Skeleton style={{ borderRadius: "10px" }} animation="wave" variant="rectangular" width={"100%"} height={130} />
          </Box> : missionData?.length > 0 ? (missionData?.map((item, index) => {
            return (
              <>
                <div className={Styles.continer} key={item?._id} >
                  <div key={"fav" + item?._id} onClick={() => { favHandler(item?._id) }} style={{ position: "absolute", top: "0px", right: "0px" }}>
                    {item?.favorite ? <img src={Fav} alt="fav" /> : <img src={Unfav} alt="fav2" />}
                  </div>
                  <div className={Styles.container1} key={item?._id}>
                    <div className={Styles.image_div}>
                      <img src={item?.image} alt="icon" />
                    </div>
                    <div className={Styles.item_container}>
                      <div className={Styles.Cash_bonanza_div}>{getTitle(item?.challenge_name)}</div>
                      <div className={Styles.Fast_food_div}>{item?.sub_category}</div>
                      <div className={Styles.fast_food_detail_container}>
                        <div className={Styles.food_detils} style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}><SmartDisplayOutlinedIcon style={{ color: "#fff", fontSize: "16px" }} /></div>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>&nbsp;&nbsp;{item?.total_questions}</div>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>&nbsp;Q</div>
                        </div>
                        |
                        <div className={Styles.food_detils} style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}><HourglassEmptyIcon style={{ color: "#fff", fontSize: "16px" }} /></div>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>&nbsp;&nbsp;{item?.duration}</div>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>&nbsp;mins</div>
                        </div>
                        |
                        <div className={Styles.food_detils} style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}><PersonOutlineOutlinedIcon style={{ color: "#fff", fontSize: "18px" }} /></div>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>&nbsp;&nbsp;{item?.total_attempted || 0}</div>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>&nbsp;</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <button onClick={() => navigate(`/start-quiz/${item._id}`)} className={Styles.button_9} role="button">
                    Get {item.reward.toFixed(2)}
                    <img className={Styles.btn_img} src={Play_btn} width={"60px"} height={"60px"} />
                  </button>
                </div>
              </>
            )
          })) : (
            <div style={{ marginTop: "20px", wordWrap: 'break-word', textAlign: "center", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", width: "100%", height: "50vh" }}>
              <p> No favourites right now</p>
            </div>

          )}

          {hasMore && <div className={Style.loadmore_box_favorite} onClick={() => setPage(page + 1)}>Load More</div>}
          {showPopup && <LimitPopup open={showPopup} setOpen={setShowPopup} />}
          {open1 && (<LimitPopup2 open={open1} setOpen={setOpen1} currentUrl={currentUrl} />)}
          <BottomBar />
        </div>
      </div>
    </>
  )
}

export default FavoriteMIssion